module.exports = __webpack_public_path__ + "static/media/2-en.122ad72c.svg";